<template>
    <div class="map-container-container">
        <img class="currentLocation" src='../../assets/rainbowlocation.png'/>
        <div ref="map" class="map-container"></div>
    </div>
</template>

<script>
  export default {
    name: "GoogleMapsLocationSelector",
    props: {
      coordinates : {
        default : () => {
          return {
            lat: 42.359586,
            lng: -71.053825
          }
        }
      }
    },
    mounted(){
      this.$googlePromise.then(() => {
        // Set coordinates
        let myLatlng = new google.maps.LatLng(this.coordinates.lat, this.coordinates.lng);

        // Options
        let mapOptions = {
          zoom: 14,
          center: myLatlng
        };

        // Apply options
        let map = new google.maps.Map(this.$refs["map"], mapOptions);

        //Add marker
        // let marker = new google.maps.Marker({
        //   position: myLatlng,
        //   map: map
        // });
        //
        // marker.setMap(map);

        //Fire once from initial set
        this.$emit('locationUpdated', this.coordinates);

        //TODO on click - center
        google.maps.event.addListener(map, "center_changed", () => {
          let lat = map.getCenter().lat();
          let lon = map.getCenter().lng();
          let newLatLng = {lat: lat, lng: lon};
          // marker.setPosition(newLatLng);

          this.$emit('locationUpdated', newLatLng)
        });
      })

    }
  }
</script>

<style lang="scss" scoped>
    .map-container-container {
        //position: relative;
    }
    .map-container, .map-container-container {
        min-height: 300px;
        min-width: 300px;
    }
    .map-container {
        height: 100%;
        width: 100%;
    }
    .currentLocation {
        pointer-events: none;
        z-index: 500;
        width: 24px;
        position: absolute;
        left: 50%;
        bottom: 50%;
        margin-left: -12px;

    }
</style>
